// extracted by mini-css-extract-plugin
module.exports = {"LoadError":"bfk_a bhu_pw bhu_a bhu_w bhu_j bhu_q","LoadError__icon":"bfk_b bhu_uf bhu_fg bhu_rq","LoadError__message":"bfk_c bhu_fg bhu_sl"};